import React from 'react'
import { HtmlContent } from 'utils'

import styles from '../styles/supplier_tricks_component.module.scss'

const OptionalSlide = ({ content, image, label }) => {

  if (content === '' && image === null)
    return null

  return (
    <>
      <div className={styles.supplier_tricks_component__wrapper}>
        {
          content !== '' ? (
            <div className={styles.supplier_tricks_component__wrapper_outer}>
              <HtmlContent
                content={content}
                className={styles.supplier_tricks_component__wrapper_inner}
              />
            </div>
          ) : (<img loading="lazy"
            src={image}
            alt=''
            className={styles.supplier_tricks_component__image}
          />)
        }

        <div className={styles.supplier_tricks_component__label}>
          {label}
        </div>
      </div>
    </>
  )
}

export default OptionalSlide